import { InfiniteData, useQueryClient } from '@tanstack/react-query'

import { Observation, ObservationsResult } from '../../types/observation'

type QueryData = InfiniteData<ObservationsResult> | undefined

export const useObservationsUpdate = () => {
  const queryClient = useQueryClient()

  const updateObservation = (observation: Observation) => {
    queryClient.setQueriesData<QueryData>(
      { queryKey: ['observations'], exact: false },
      (data: QueryData): QueryData => {
        if (data) {
          return {
            ...data,
            pages: data.pages.map((page) => ({
              ...page,
              results: page.results.map((o) =>
                o.id === observation.id ? observation : o
              ),
            })),
          }
        }
        return data
      }
    )
  }

  return { updateObservation }
}
